<template>
  <div>
    <ValidationObserver tag="span" class="validation posr" v-slot="{handleSubmit}">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="form-group">
          <ValidationProvider tag="div" class="validation posr" :rules="{required: true, regex: /^09\d{8}$/}" v-slot="{errors}">
            <input v-model="cell" type="text" class="form-control" placeholder="手機號碼">
            <div class="error">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <ValidationProvider tag="div" class="validation posr" rules="required|email" v-slot="{errors}">
            <input v-model="email" type="email" class="form-control" placeholder="電子郵件">
            <div class="error">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="comment-btn text-right">
          <button type="submit" class="btn btn-orange submit-btn">送出</button>
        </div>
      </form>
    </ValidationObserver>
    <!-- order lists -->
    <div v-if="orders.length > 0" class="mt20">
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead>
            <th nowrap>No.</th>
            <th nowrap>預訂時間</th>
            <th nowrap>空間</th>
            <th nowrap>應付金額</th>
            <th nowrap>付款狀態</th>
            <th nowrap>訂單狀態</th>
            <th nowrap>開關碼</th>
            <th nowrap>功能</th>
          </thead>
          <tbody>
            <tr v-for="(order, index) in orders" :key="index">
              <td nowrap :class="order.time_over_or_disabled ? 'over' : ''">{{index + 1}}</td>
              <td nowrap :class="order.time_over_or_disabled ? 'over' : ''">{{order.show_time}}</td>
              <td nowrap :class="order.time_over_or_disabled ? 'over' : ''">{{order.room_title}}</td>
              <td nowrap :class="order.time_over_or_disabled ? 'over' : ''">{{order.real_amount}}</td>
              <td nowrap :class="order.time_over_or_disabled ? 'over' : ''">{{order.show_bank_status}}</td>
              <td nowrap :class="order.time_over_or_disabled ? 'over' : ''">{{order.show_status}}</td>
              <td nowrap :class="order.time_over_or_disabled ? 'over' : ''">{{order.masked_access_code}}</td>
              <td nowrap>
                <a v-if="!order.time_over_or_disabled" @click.prevent="getAccessCode(order.key)" class="btn btn-em">Email開關碼</a>
                <a v-if="order.refundable" @click.prevent="cancelOrder(order.key)" class="btn btn-default">取消預訂</a>
                <div v-if="order.time_over_or_disabled" class="over">訂單結束/無效</div>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="notice">*請左右滑動查看資訊</p>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import { extend } from 'vee-validate';
import { required, regex, email } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';

extend('required', {
  ...required,
  message: '欄位為必填'
});

extend('email', {
  ...email,
  message: "請確認格式"
});

extend('regex', {
  ...regex,
  message: "欄位格式錯誤"
})

export default {
  data: function() {
    return {
      cell: null,
      email: null,
      orders: []
    }
  },
  methods: {
    onSubmit() {
      // 檢查並撈出資料
      const {cell, email} = this;
      const self = this;
      const url = '/bookings/check';
      const csrf = document.head.querySelector("meta[name=csrf-token]").content;
      axios.defaults.headers.common['X-CSRF-Token'] = csrf;
      axios.post(url, {cell, email})
           .then(function(response) {
             const {data} = response;
             console.log(data);
             if (data.status === 'ok' && data.orders.length > 0) {
               self.orders = data.orders;
             } else {
              //  失敗
              Swal.fire({
                title: '搜尋失敗',
                text: data.message,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                confirmButtonText: '我瞭解了'
              })
             }
           })
           .catch(error => console.log(error));
    },
    getAccessCode(key) {
      // console.log("access")
      const url = '/bookings/get_access_code';
      const csrf = document.head.querySelector("meta[name=csrf-token]").content;
      axios.defaults.headers.common['X-CSRF-Token'] = csrf;
      axios.post(url, {key}).then((response) => {
        const {data} = response;
        if (data.status === 'ok') {
          Swal.fire({
            title: '寄發通知',
            text: data.message,
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
        } else {
          Swal.fire({
            title: '取得失敗',
            text: data.message,
            icon: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: '我瞭解了'
          })
        }
      }).catch(error => console.log(error));
    },
    cancelOrder(key) {
      const self = this;
      const url = '/bookings/cancel_order';
      const csrf = document.head.querySelector("meta[name=csrf-token]").content;
      axios.defaults.headers.common['X-CSRF-Token'] = csrf;
      axios.post(url, {key}).then((response) => {
        const {data} = response;
        if (data.status === 'ok') {
          Swal.fire({
            title: '取消訂單審核',
            text: data.message,
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          self.orders = data.orders;
        } else {
          Swal.fire({
            title: '發生錯誤',
            text: data.message,
            icon: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: '我瞭解了'
          })
        }
      }).catch(error => console.log(error));
    }
  }
}
</script>

<style>
  .table td, .table th {
    height: 40px;
    text-align: center;
    padding: 0 15px;
  }
  .table td.over {
    color: #d9d9d9;
  }
  .over {
    color: #d9d9d9;
  }
  a.btn {
    padding: 4px 15px;
  }
  .btn.btn-default {
    border: 1px solid #2aacaf;
    color: #2aacaf;
  }
  .btn.btn-default:hover {
    background: #2aacaf;
    color: #fff;
  }
  .btn-em {
    background: #2aacaf;
    border: 1px solid #fff;
    color: #5f5f5f;
  }
  .btn.btn-em:hover {
    border: 1px solid #2aacaf;
    background: #fff;
    color: #2aacaf;
  }

</style>